import { getOrderRow } from '../utils/utils'

export default {
    ADD_TO_ORDERS(state, lists) {
        const searches = []
        if (lists != null) {
            lists.forEach(e => {
                searches.push(getOrderRow(e))
            })
            state.orders = searches
        } else {
            state.orders = []
        }
    },
    SET_COUNT(state, count) {
        state.totalOrders = count
    },
    SET_PARAMS(state, params) {
        state.paramsSearch = params
    },
    ADD_TO_STATUSES(state, data) {
        data.forEach(e => {
            state.statuses.push(e)
        })
    },
    SET_ERROR_ORDERS_DATA(state, data) {
        state.errorOrdersData = data
    },
}
